import styled from '@emotion/styled';
import { IFacet } from '~/lib/data-contract';
import { Facet } from './Facet';

export const StyledFacetsWrapper = styled.div(({ theme }) => ({
	display: 'flex',
	gap: theme.space[6],
}));

export type FacetsProps = {
	facets: IFacet[];
	onFacetSelected: (facetId: string) => void;
	expandedFacetId: string | null;
};

export const Facets = (props: FacetsProps) => {
	const { facets, expandedFacetId, onFacetSelected } = props;

	return (
		<StyledFacetsWrapper
			role="tablist"
			aria-label="Facet tabs"
		>
			{facets.map((facet) => (
				<Facet
					key={facet.id}
					expanded={expandedFacetId === facet.id}
					onClick={onFacetSelected}
					{...facet}
				/>
			))}
		</StyledFacetsWrapper>
	);
};
